module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pageTitle', {
    attrs: {
      "title": "开通储值卡"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "hint"
  }, [_vm._v("\n        温馨提示：为保证您的储值卡安全，初次使用会员储值功能需要先设置储值支付密码。\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": "/wallet/valueCardRule"
    }
  }, [_vm._v("查看储值优惠政策及使用规则 >")])], 1)]), _vm._v(" "), _c('inputBox', {
    attrs: {
      "disabled": true,
      "label": "手机号码",
      "value": _vm.phone
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请输入密码",
      "label": "密码",
      "secret": true
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请输入确认密码",
      "label": "确认密码",
      "secret": true
    },
    model: {
      value: (_vm.passCheck),
      callback: function($$v) {
        _vm.passCheck = $$v
      },
      expression: "passCheck"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请输入图片验证码",
      "label": "图片验证码",
      "extendType": "icon",
      "extendSrc": _vm.TPFJM
    },
    on: {
      "extendHandler": _vm.getValidateCode
    },
    model: {
      value: (_vm.imgValid),
      callback: function($$v) {
        _vm.imgValid = $$v
      },
      expression: "imgValid"
    }
  }), _vm._v(" "), _c('inputBox', {
    attrs: {
      "hintMsg": "请输入手机验证码",
      "label": "手机验证码",
      "extendType": "button",
      "extendSrc": "获取验证码",
      "countDownSeconds": _vm.countDown
    },
    on: {
      "extendHandler": _vm.getPhoneValid
    },
    model: {
      value: (_vm.phoneValid),
      callback: function($$v) {
        _vm.phoneValid = $$v
      },
      expression: "phoneValid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "open"
  }, [_c('mu-raised-button', {
    attrs: {
      "fullWidth": true,
      "label": "立即开通",
      "primary": ""
    },
    on: {
      "click": _vm.open
    }
  })], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.hintMsg
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15903e44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/openValueCard.vue
// module id = 1431
// module chunks = 18